import { Component, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { TicketManagementService } from "@services/ticket-management.service";
import { take } from "rxjs";
import { ButtonComponent } from "../button/button.component";
import { DialogHeaderComponent } from "../dialog-header/dialog-header.component";

export interface BatchTransitionDialogData {
  batchId: number;
  nextBatchNumber: number;
  /** When set, only these ticket types advance (independent meia/inteira). */
  ticketIds?: number[];
  ticketTitle?: string;
}

@Component({
  selector: "app-batch-transition-modal",
  imports: [MatDialogModule, ButtonComponent, DialogHeaderComponent],
  templateUrl: "./batch-transition-modal.component.html",
  styleUrl: "./batch-transition-modal.component.scss",
})
export class BatchTransitionModalComponent {
  readonly data = inject<BatchTransitionDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(
    MatDialogRef<BatchTransitionModalComponent>,
  );
  private readonly tickets = inject(TicketManagementService);
  loading = false;
  errorMessage = "";

  cancel(): void {
    if (!this.loading) this.dialogRef.close();
  }

  confirm(): void {
    if (this.loading) return;
    this.loading = true;
    this.errorMessage = "";
    this.dialogRef.disableClose = true;
    this.tickets
      .transitionBatch(
        this.data.batchId,
        this.isTicketTransition ? { ticketIds: this.data.ticketIds } : undefined,
      )
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          if (
            !Array.isArray(response?.batches) ||
            response.batches.length === 0
          ) {
            this.showError(
              "A resposta não confirmou os lotes atualizados. Atualize a página para conferir o estado antes de tentar novamente.",
            );
            return;
          }
          this.dialogRef.close(response.batches);
        },
        error: (error: { status?: number; error?: { error?: string } }) => {
          const subject = this.data.ticketIds?.length ? "ingresso" : "lote";
          this.showError(
            error.status === 403
              ? `Você não tem permissão para virar este ${subject}.`
              : error.error?.error ||
                  `Não foi possível confirmar a virada. Atualize a página para conferir o estado do ${subject}.`,
          );
        },
      });
  }

  get isTicketTransition(): boolean {
    return !!this.data.ticketIds?.length;
  }

  private showError(message: string): void {
    this.loading = false;
    this.dialogRef.disableClose = false;
    this.errorMessage = message;
  }
}
